import request from "utils/request";

export async function getContentGroups() {
	return request("/rest/content_groups");
}

export async function createContentGroup(payload) {
	return request("/rest/content_groups", {
		method: "PUT",
		body: payload
	});
}

export async function renameContentGroup(payload) {
	return request("/action/rename/content_group", {
		method: "POST",
		body: payload
	});
}

export async function saveContentGroup(payload) {
	return request("/rest/content_groups", {
		method: "POST",
		body: payload
	})
}

export async function deleteContentGroups(ids) {
	return request("/rest/content_groups", {
		method: "DELETE",
		body: ids
	});
}

export async function getContentGroup(contentGroupId) {
	return request("/rest/content_group/" + contentGroupId);
}

export async function deleteArticles(contentGroupId, articleIds) {
	return request("/rest/article/" + contentGroupId, {
		method: "DELETE",
		body: articleIds
	});
}

export async function getArticle(id) {
	return request("/rest/article/" + id);
}

export async function getSampleArticle(contentGroupId) {
	return request("/rest/new_article/" + contentGroupId);
}

export async function downloadArticleForgeArticle(payload) {
	return request("/action/download/article/", {
		method: "POST",
		body: payload
	});
}
//Payload is in the form of:
// {
// 	articleSource: "BuiltInArticleBuilder",
// 	inputInfo: "{"categoryId":"acid reflux","wordCount":500,"spinArticle":false}"
// }
export async function downloadRankerXArticle(payload) {
	return request("/action/download/article/", {
		method: "POST",
		body: payload
	});
}

//Payload is in the form of:
// {
// 	articleSource: "ArticleBuilder",
// 	inputInfo: "{"categoryId":"acid reflux","wordCount":500,"spinArticle":false}"
// }
export async function downloadArticleBuilderArticle(payload) {
	return request("/action/download/article/", {
		method: "POST",
		body: payload
	});
}

export async function generateArticles(payload) {
	return request("/action/generate/articles/", {
		method: "POST",
		body: payload
	});
}

export async function stopGeneratingArticles(contentGroupId) {
	console.log("/action/stop-generating/articles/" + contentGroupId);
	return request("/action/stop-generating/articles/" + contentGroupId);
}

export async function downloadUSAArticle(payload) {
	return request("/action/download/article/", {
		method: "POST",
		body: payload
	});
}

export async function saveArticle(payload) {
	return request("/rest/article", {
		method: "POST",
		body: payload
	})
}

export async function spinArticle(contentGroupId, payload) {
	return request("/action/spin/article/" + contentGroupId, {
		method: "POST",
		body: payload
	});
}

export async function downloadKMCampaigns() {
	return request("/action/download/kmcampaigns");
}

//Payload is in the form of:
// {
// 	articleSource: "KontentMachine,
// 	inputInfo: "CE9C7E2401E9536F092774DD12BB4FE5
// }
export async function downloadKMArticles(contentGroupId, payload) {
	return request("/action/download/kmarticles/" + contentGroupId, {
		method: "POST",
		body: payload
	})
}
